import { i18n } from '@fs/zion-locale'

export default function getReworkStatusLabel(status) {
  const statusMapping = {
    Completed: i18n.t('reworkStatusLabel.completed', 'Completed'),
    Requested: i18n.t('reworkStatusLabel.requested', 'Requested'),
    'In Progress': i18n.t('reworkStatusLabel.inProgress', 'In Progress'),
    Cancelled: i18n.t('reworkStatusLabel.cancelled', 'Cancelled'),
    Available: i18n.t('reworkStatusLabel.available', 'Available'),
    Approved: i18n.t('reworkStatusLabel.approved', 'Approved'),
  }

  return statusMapping[status] ?? ''
}
